exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-content {\r\n    display: none;\r\n    position: absolute;\r\n    background-color: #022699;\r\n    width: 101%;\r\n    margin-left: -3px;\r\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\r\n    z-index: 1;\r\n}\r\n\r\n.dropdown-content a {\r\n    color: #f0f0f0;\r\n    padding: 12px 16px;\r\n    text-decoration: none;\r\n    display: block;\r\n    text-align: left;\r\n}\r\n\r\n.dropdown-content a:hover {\r\n    background-color: #f0f0f0;\r\n    color: #002699;\r\n}\r\n\r\n.dropdown:hover .dropdown-content {\r\n    display: block;\r\n}\r\n\r\n.dropdown-content hr {\r\n    margin: -3px 0;\r\n    height: 2px;\r\n    background-color: #f0f0f0;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/dropdown.css
// module id = 51
// module chunks = 0